export const timeRangeOverride = {
  'AccountPerformanceReport-SixWeeks':
  {
    Weekly: ['LastSixWeeksStartingSun', 'Custom'],
    WeeklyStartingMonday: ['LastSixWeeksStartingMon', 'Custom'],
  },
  'AccountPerformanceReport-TwoMonths': {
    Monthly: ['LastTwoMonths', 'Custom'],
  },
  'AccountPerformanceReport-TwoYears': {
    Monthly: ['LastTwoYears', 'Custom'],
  },
};
